/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Note } from '../../lib/wwg.classes';
import { AuthService } from '../../sdk/services/core/auth.service';

@Component({
  selector: 'app-add-note-dialog',
  templateUrl: './add-note-dialog.component.html',
  styleUrls: ['./add-note-dialog.component.scss']
})
export class AddNoteDialogComponent {

  note: string;
  notes = new Array<Note>();

  constructor(
    public dialogRef: MatDialogRef<AddNoteDialogComponent>,
    public authService: AuthService ) { }

  addNote() {
    const note = new Note();
    note.note = this.note;
    if (this.note && this.note.length > 0) {
      note.author = this.authService.getUserId();
      this.notes.push(note);
      this.dialogRef.close(this.notes);
    }
  }
}
